export default __webpack_public_path__ + "static/media/closet5-after1-1440w.106c1f3b.webp";